import React from 'react'
import styles from '../stylesheets/Portfolio.module.scss'
import Headline from './Headline'
import Fade from 'react-reveal/Fade'

function Portfolio() {
  return (
    <div>
      <Fade>
        <Headline title="PORTFOLIO" />
      </Fade>
      <div className="row halfhalf port">
        <Fade bottom>
          <div className={`${styles.wrapper} ${styles.monkee}`}>
            <div className={styles.overlay}>
              <div className={`${styles.items} ${styles.head}`}>
                <p className={styles.title}>Monkee World</p>
                <p className={styles.skills}>Rails - Ruby - JS</p>
                <p className={styles.description}>Le Wagon collaborative project</p>
              </div>
              <div className={`${styles.items} ${styles.link}`}>
                <a href="https://monkee-app.herokuapp.com/" target="_blank" rel="noopener noreferrer">OPEN</a>
              </div>
            </div>
          </div>
        </Fade>
        <Fade delay={200} bottom>
          <div className={`${styles.wrapper} ${styles.ap}`}>
            <div className={styles.overlay}>
              <div className={`${styles.items} ${styles.head}`}>
                <p className={styles.title}>arnepedersen.io</p>
                <p className={styles.skills}>React - JS - Node.js</p>
                <p className={styles.description}>My homepage.</p>
              </div>
              <div className={`${styles.items} ${styles.link}`}>
                <a href="#home">OPEN</a>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  )
}

export default Portfolio
